


































import Vue, { PropType } from 'vue';
import Dropdown from '../../dropdowns/basics/Dropdown/Dropdown.vue';
import InputWrapper from '../bases/InputWrapper/InputWrapper.vue';
import DropdownIndicator from '../../dropdowns/basics/DropdownIndicator/DropdownIndicator.vue';
import DropdownItems from '../../dropdowns/basics/DropdownItems/DropdownItems.vue';
import DropdownItemGroup from '../../dropdowns/basics/DropdownItemGroup/DropdownItemGroup.vue';
import pointerMixin from '../../dropdowns/pointerMixin';
import BaseFormElem from '../bases/BaseFormElem.vue';

const ICON_ACTIVE = 'dropup-active';
const ICON_INACTIVE = 'dropdown-inactive';

interface OptionObject {
  label: string;
  value: string;
  disabled?: boolean;
}

export default Vue.extend({
  name: 'select-input',
  extends: BaseFormElem,
  mixins: [pointerMixin],
  components: {
    Dropdown,
    InputWrapper,
    DropdownIndicator,
    DropdownItems,
    DropdownItemGroup,
  },
  props: {
    value: String,
    options: Array as PropType<string[] | OptionObject[]>,
    disabled: Boolean,
    placeholder: {
      type: String,
      default: 'Select an option',
    },
  },
  data() {
    return {
      iconActive: ICON_ACTIVE,
      iconInactive: ICON_INACTIVE,
    };
  },
  methods: {
    handleClick(option: OptionObject, close: () => void) {
      this.select(option);
      close();
    },
    select(option: OptionObject) {
      if (option.disabled) { return; }
      this.$emit('input', option.value);
    },
  },
  computed: {
    normalizedOptions(): OptionObject[] {
      if (this.options && Array.isArray(this.options) && this.options.length > 0) {
        if (typeof(this.options[0]) === 'object') {
          return this.options as OptionObject[];
        } else if (typeof(this.options[0]) === 'string') {
          return (this.options as string[]).map((cur)=> {
            return {
              label: cur,
              value: cur,
            };
          });
        }
      }
      return [];
    },
    selectedLabel(): string {
      const selected = this.normalizedOptions.find((cur) => {
        return cur.value === this.value;
      });
      if (selected) {
        return selected.label;
      }
      return '';
    },
  },
});
